// @flow

import { useState, useEffect } from 'react';
import { init } from '@ebanx/ebanx-js';
import { type IncomingPayment, getCountry, getMerchant } from '@tectonics/prs/incoming-payment';
import { getPublicIntegrationKey } from '@tectonics/prs/merchant';
import { useControllerContext } from './context';

export function useEbanxJsInitialization(payment: ?IncomingPayment) {
  const [country, setCountry] = useState<string>('');
  const [mode, setMode] = useState<string>('');
  const [publicIntegrationKey, setPublicIntegrationKey] = useState<string>('');
  const { localTenancy } = useControllerContext();

  useEffect(() => {
    if (!country || !mode || !publicIntegrationKey) {
      return;
    }
    init({ country, mode, publicIntegrationKey, tenant: localTenancy });
  }, [country, mode, publicIntegrationKey, localTenancy]);

  useEffect(() => {
    if (!payment) {
      return;
    }

    setCountry(getCountry(payment));
    setMode(ENV_CONSTANTS.ENV === 'production' ? 'production' : 'test');
    setPublicIntegrationKey(getPublicIntegrationKey(getMerchant(payment)));
  }, [payment]);
}
